/**
 * 用户统计 — GET /api/admin/stats/users
 */
import { Card, Col, Row, Table, Tag } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';

interface Breakdown {
  by_status: { key: string; count: number }[];
  by_level: { key: string; count: number }[];
  by_kyc: { key: string; count: number }[];
}

export function StatsUserPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'stats', 'users'],
    queryFn: () => api.get<Breakdown>('/api/admin/stats/users'),
  });

  const col = [
    { title: '键', dataIndex: 'key', render: (v: string) => <Tag>{v}</Tag> },
    { title: '数量', dataIndex: 'count', width: 120 },
  ];

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>用户统计</h2>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Card title="按状态" loading={isLoading} size="small">
            <Table
              size="small"
              pagination={false}
              rowKey="key"
              columns={col}
              dataSource={data?.by_status ?? []}
            />
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card title="按等级" loading={isLoading} size="small">
            <Table
              size="small"
              pagination={false}
              rowKey="key"
              columns={col}
              dataSource={data?.by_level ?? []}
            />
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card title="按 KYC" loading={isLoading} size="small">
            <Table
              size="small"
              pagination={false}
              rowKey="key"
              columns={col}
              dataSource={data?.by_kyc ?? []}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
